import React from 'react';
import { useHistory } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/failed.png';


interface Props extends PropsFromRedux {}

const CustomerValidationError: React.FC<Props> = ({ hideModal, showModal, modal }) => {
  
  const history = useHistory();
  
  const closeModal = () => {
    hideModal();
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={checkImg} alt="GIG App" className="w-12 my-4" />
    </div>
     <div className="w-full my-6 text-center">
         <h2 className="mb-1 text-lg font-medium text-black">Validation Failed</h2>
         <p>Make sure your smart card / meter number is valid</p>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Close</button>

  </div>
  );
  // </ModalWrapper>
};

export default CustomerValidationError;